export default __webpack_public_path__ + "static/media/quote.8f54ab34.svg";